import * as L from 'leaflet'
import { WeatherSymbolHandler } from '@map-sdk/sdk/plugins/weather/util/WeatherSymbolHandler'
import { showWeatherTipMessage } from './ShowWeatherTipMessage'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
import type { ShowFullScreenTitleLayer } from '@map-sdk/sdk/plugins/weather/util/ShowFullScreenTitleLayer'
export class FullScreenSymbol {
  private _map: MyMap
  private _symbolLayer: L.LayerGroup
  private types: number
  private data: any
  private fullScreenTitleLayer?: ShowFullScreenTitleLayer // 假设 L.ShowFullScreenTitleLayer 是一个有效的 Leaflet 扩展

  private weatherMsg: any

  constructor(map: MyMap, type: number, data?: any) {
    this._map = map
    this._symbolLayer = L.layerGroup().addTo(map)
    this.types = type
    this.data = data
  }

  // TODO: 暂未请求接口
  private loadData(reload = false): void {
    const { types } = this
    const zoom = this._map.getZoom()
    if (!(zoom < 2 || zoom > 7)) {
      // let data = types === 15 ? (hl as any).data : (test as any).data
      if (this.data && !reload) {
        this._displayData(this.data, types)
      } else {
        this.data = this.adjustData(this.data)
        this._displayData(this.data, types)
      }
    }
  }

  _displayData(data: any[], dataType: number) {
    const weatherSymbolHandler = new WeatherSymbolHandler(
      this._map,
      this._symbolLayer
    )
    weatherSymbolHandler.displayWeatherData(data, dataType)
  }
  adjustData(rawData: any[]) {
    const adjustedData = JSON.parse(JSON.stringify(rawData))
    for (const point of adjustedData) {
      if (point.x > 0) {
        point.x -= 360000
      } else if (point.x < 0) {
        point.x += 360000
      }
    }

    return rawData.concat(adjustedData)
  }
  private _Event = {
    moveend: () => this.moveHandle(),
  }
  public show(data?: any, QBBeginTime?: Record<string, any>): void {
    console.log(data, QBBeginTime)
    this.remove()
    // this._forecasttime = `${CanvasShipUtils.dataFormat(new Date(), 'YYYY-MM-DD')} 20:00:00`
    // data && data.length > 0 && (this._forecasttime = data)
    // this._QBBeginTime = QBBeginTime
    this.loadData(true)
    this._map.on('moveend ', this._Event.moveend)
    this.weatherMsg = showWeatherTipMessage(
      this._map,
      this.types === 13 ? 'showWind' : 'showHL'
    )
  }
  private moveHandle() {
    this._symbolLayer.clearLayers()
    this.loadData()
  }

  public remove(): void {
    this.fullScreenTitleLayer &&
      this.fullScreenTitleLayer.hideFullScreenTileLayer()
    this._symbolLayer.clearLayers()
    this._map.off('moveend', this._Event.moveend)
    this.weatherMsg && this.weatherMsg.offRegisterEvent()
  }
}
